import React, { useEffect } from 'react';

import {
  Pagination as MuiPagination,
  Stack,
  TablePaginationProps,
} from '@mui/material';
import {
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';

import ControlledTextField from '../Components/ControlledTextField';
import { useResponsive } from '../Components/ResponsiveProvider';

function CustomPagination({
  page,
  onPageChange,
  className,
  isLoading = false,
}: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'> & {
  isLoading?: boolean;
}) {
  const apiRef = useGridApiContext();
  const { isMobile } = useResponsive();

  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: { pageNumber: page + 1 },
  });

  const onSubmit = (data: { pageNumber: number }) => {
    if (isLoading) return;
    const newPage = data.pageNumber - 1;
    if (newPage >= 0 && newPage < pageCount) {
      apiRef.current.setPage(newPage);
    }
  };

  useEffect(() => {
    setValue('pageNumber', page + 1);
  }, [page]);

  return (
    <Stack
      direction="row"
      spacing={isMobile ? 0 : 2}
      alignItems="center"
      flexWrap="wrap"
      justifyContent="end"
      minWidth="460px"
    >
      <MuiPagination
        className={className}
        color="primary"
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
        size={isMobile ? 'small' : 'medium'}
        disabled={isLoading}
        {...(isMobile && { siblingCount: 0 })}
      />
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginLeft: '10px' }}>
        <ControlledTextField
          name="pageNumber"
          control={control}
          rules={{ min: 1, max: pageCount }}
          label="Page No."
          type="number"
          variant="outlined"
          size="small"
          disabled={isLoading}
          InputProps={{ inputProps: { min: 1, max: pageCount } }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              handleSubmit(onSubmit)();
            }
          }}
          sx={{
            width: isMobile ? '70px' : '80px',
          }}
        />
      </form>
    </Stack>
  );
}

export default CustomPagination;
